import * as React from 'react';
import axios from 'axios';
import { getUserId } from '../mon-compte/MonCompteAction';
import { checkStock, getEnv, getHostApi, getRequestConfig } from '../../utils';
import { StockErrors } from '../cart/cartInterfaces';

//eslint-disable-next-line
declare var paypal: any;

interface PaypalCheckoutProps {
  containerId?: string;
  cartId?: string;
  orderId?: string;
  style?: Record<string, unknown>;
  onPaymentRequested?: () => void;
  onPaymentApproved?: (data: any) => void;
  onPaymentConfirmed?: () => void;
  onPaymentCancel?: (data: any) => void;
  onPaymentError?: (data: any) => void;
  onStockError?(stockErrors: StockErrors): void;
}


export class PaypalCheckout extends React.Component<PaypalCheckoutProps, Record<string, unknown>> {

  private createUrl?: string;
  private executeUrl?: string;

  constructor(props: PaypalCheckoutProps) {
    super(props);

    this.setPaypalUrl();
  }

  private setPaypalUrl() {
    if (this.props.cartId) {
      this.createUrl = `${getHostApi()}/carts/${this.props.cartId}/paypal/flow/create`;
    } else if (this.props.orderId) {
      const userId = getUserId();

      this.createUrl = `${getHostApi()}/customers/${userId}/orders/${this.props.orderId}/paypal/create`;
      this.executeUrl = `${getHostApi()}/customers/${userId}/orders/${this.props.orderId}/paypal/confirm`;
    }
  }

  private getContainerId() : string {
    if (!this.props.containerId) {
      return 'paypal-container';
    }

    return this.props.containerId;
  }

  componentDidMount() {
    const env = getEnv();

    paypal.Button.render({
      env: (env === 'development' || env === 'preprod') ? 'sandbox' : 'production',
      style: {
        size: 'responsive',
        color: 'silver',
        shape: 'rect',
        label: 'pay',
        tagline: false,
      },

      payment: () => {
        return checkStock(this.props.cartId || '')
          .then(() => {
            if (this.props.onPaymentRequested) {
              this.props.onPaymentRequested();
            }

            return axios.post(this.createUrl as string, {}, getRequestConfig())
              .then((res) => {
                return res.data.id;
              }).catch((err) => { console.error(err); });
          })
          .catch((err) => {
            if(this.props?.onStockError) {
              this.props.onStockError(err);
            }
          });
      },

      onAuthorize: (data: any, actions: any) => {
        if (this.props.onPaymentApproved) {
          this.props.onPaymentApproved(data);
        }

        if (this.executeUrl) {
          return axios.post(this.executeUrl, data, getRequestConfig())
            .then((res) => {
            if (this.props.onPaymentConfirmed) {
              this.props.onPaymentConfirmed();
            }
          }).catch((err) => {
            console.error(err);
          });
        }
      },

      onCancel: (data: any, actions: any) => {
        if (this.props.onPaymentCancel) {
          this.props.onPaymentCancel(data);
        }
      },

      onError: (data: any) => {
        if (this.props.onPaymentError) {
          this.props.onPaymentError(data);
        }
      },
    }, `#${this.getContainerId()}`);
  }

  render() {
    return <div style={this.props.style} id={this.getContainerId()}/>;
  }
}
